import React, { useContext, SyntheticEvent, useState, useEffect } from "react";

import { Adress } from "../../../helpFunction/urlList";
import { ContextHome } from "../../../contextHomeCloude/contextHome";
import "./renameFile.css";
import { paramsQuery } from "../../../helpFunction/helpFunction";
import { toast } from "react-toastify";
import { propsFileName } from "../../DataListFtp/DataListFtp";

interface Props {
	newFileName: propsFileName;
	setNewFileName: (e: propsFileName | null) => void;
	path: string;
}

export const RenameFile = ({ newFileName, setNewFileName }: Props) => {
	const context = useContext(ContextHome);
	const [fileType, setFileType] = useState("");
	const [fileNameOld, setFileNameOld] = useState("");

	useEffect(() => {
		chackFileType();
	}, []);

	if (!context) return null;
	const { setLoading, path, clearAndReload } = context;

	const anuluj = () => {
		setNewFileName(null);
	};

	const chackFileType = (): string => {
		let fileType = "";
		let index = newFileName.old.lastIndexOf(".");

		if (index === -1) {
			fileType = "";
			index = newFileName.old.length;
		} else {
			fileType = newFileName.old.slice(index, newFileName.old.length).toLowerCase();
		}
		setNewFileName({ ...newFileName, new: newFileName.old.slice(0, index) });
		setFileType(fileType);
		return fileType;
	};

	const validateName = (name: string) => {
		// if (name.includes(".")) return;
		setNewFileName({ ...newFileName, new: name });
	};
	const renameFile = async (e: SyntheticEvent) => {
		e.preventDefault();
		setLoading("Czekaj ...");
		try {
			const data = await fetch(`${Adress.renameFile}/?${paramsQuery(path, newFileName.old)}&newName=${newFileName.new + fileType}`, {
				method: "put",
			});
			if (data.status === 200) {
				toast.success(`Pomyślnie zmieniono ${newFileName.old}`);
			} else {
				toast.error(`Błąd przy zmianie ${newFileName.old}`);
			}
		} catch (error) {
			console.log(error);
		}
		setNewFileName(null);
		clearAndReload();
	};
	return (
		<>
			<form className="formRename" onSubmit={renameFile}>
				<p className="formRenameLabel">Zmiana Nazwy Pliku</p>
				<div className="divInputs">
					<label>
						<input
							type="text"
							autoFocus
							title="new FileName"
							value={newFileName.new}
							required
							minLength={1}
							onChange={(e) => validateName(e.currentTarget.value)}
							placeholder={newFileName.old}
							className="formRenameInput"
							name="fileName"
						/>
					</label>

					{fileType && (
						<span title="new FileName" className="formRenameInputType">
							{fileType}
						</span>
					)}
				</div>
				<div className="buttonsRename">
					<button type="reset" onClick={anuluj}>
						- Anuluj -
					</button>
					<button type="submit" className="zapisz" onClick={renameFile}>
						- Zapisz -
					</button>
				</div>
				<input type="submit" onClick={renameFile} hidden />
			</form>
		</>
	);
};
